import React from 'react';
import { RadioListTitle, RadioListUl } from './radio-list.style';
import RadioWithLabel from '../radio-with-label/radio-with-label';
import { qaAttribute } from '../utils/qa-service';

export type ListData = {
    disabled: boolean;
    displayValue: string;
    selected: boolean;
    value: string;
    border?: boolean;
}[];

const RadioList = ({
    title,
    data,
    listName,
    elName,
    selectedValue,
    setSelectedValue,
    setSelectedDisplayName,
    searchTerm,
    tooltipMessage,
    border = false,
}: {
    title: string;
    data: ListData;
    listName: string;
    elName: string;
    selectedValue: string | undefined;
    setSelectedValue: Function;
    setSelectedDisplayName: Function;
    searchTerm?: string;
    tooltipMessage?: string | React.ReactNode;
    border?: boolean;
}) => {
    return (
        <div>
            <RadioListTitle title={title} {...qaAttribute(`${elName}-radio-list-title`)}>
                {title}
            </RadioListTitle>
            <RadioListUl {...qaAttribute(`${elName}-radio-list`)} border={border}>
                {data.map((item) => (
                    <RadioWithLabel
                        key={item.value}
                        id={item.value}
                        border={border}
                        label={item.displayValue}
                        listName={listName}
                        isDisabled={item.disabled}
                        selectedValue={selectedValue}
                        setSelectedValue={setSelectedValue}
                        setSelectedDisplayName={setSelectedDisplayName}
                        searchTerm={searchTerm}
                        hasTooltip={item.disabled}
                        tooltipMessage={tooltipMessage}
                    />
                ))}
            </RadioListUl>
        </div>
    );
};

export default RadioList;
